import React from "react";
import JoinDiscordButton from "../images/discord.png";

function Header() {
  return (
    <div className="pt-24 text-white pb-8">
      <div className="container px-3 mx-auto items-center text-center">
        <div className="mt-12">
          <p className="leading-normal text-2xl"><b>ilox</b> is a free (and friendly) stock tracking community</p>
          <p className="opacity-50 mb-6">by <a href="https://twitter.com/nehalist" className="hover:underline" target="_blank" rel="noreferrer">@nehalist</a></p>
        </div>
      </div>
      <div className="mx-auto container grid md:grid-cols-4 sm:grid-cols-2 xs:grid-cols-1 mb-12 gap-1 items-center justify-center">
        <a href="https://twitter.com/ilovertx3000" target="_blank" rel="noreferrer">
          <div className="max-w-sm rounded overflow-hidden transition transition duration-500 ease-in-out shadow-lg bg-white w-full hover:shadow-2xl mx-auto transform hover:-translate-y-2">
            <img className="w-full object-cover object-center object-top h-48" src="https://pbs.twimg.com/profile_images/1307679691134955522/gJzBz1Ca_400x400.jpg" alt="ilovertx3000"/>
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2 text-gray-800">@ilovertx3000</div>
              <p className="text-gray-700 text-base">
                Tracking nVidia RTX 3000 GPUs.
              </p>
            </div>
          </div>
        </a>
        <a href="https://twitter.com/iloveps_5" target="_blank" rel="noreferrer">
          <div className="max-w-sm rounded overflow-hidden transition duration-500 ease-in-out shadow-lg bg-white w-full hover:shadow-2xl mx-auto transform hover:-translate-y-2">
            <img className="w-full object-cover object-center object-top h-48" src="https://pbs.twimg.com/profile_images/1309962774714421249/7iuUYq_F_400x400.jpg" alt="iloveps_5"/>
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2 text-gray-800">@iloveps_5</div>
              <p className="text-gray-700 text-base">
                Tracking Sonys Playstation 5.
              </p>
            </div>
          </div>
        </a>
        <a href="https://twitter.com/ilovexboxsx" target="_blank" rel="noreferrer">
          <div className="max-w-sm rounded overflow-hidden transition duration-500 ease-in-out shadow-lg bg-white w-full hover:shadow-2xl mx-auto transform hover:-translate-y-2">
            <img className="w-full object-cover object-center object-top h-48" src="https://pbs.twimg.com/profile_images/1454122701245882373/5TynJu_F_400x400.jpg" alt="iloveps_5"/>
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2 text-gray-800">@iloveboxsx</div>
              <p className="text-gray-700 text-base">
                Tracking XBox Series X.
              </p>
            </div>
          </div>
        </a>
        <a href="https://twitter.com/iloverx6000" target="_blank" rel="noreferrer">
          <div className="max-w-sm rounded overflow-hidden transition duration-500 ease-in-out shadow-lg bg-white w-full hover:shadow-2xl mx-auto transform hover:-translate-y-2">
            <img className="w-full object-cover object-center object-top h-48" src="https://pbs.twimg.com/profile_images/1345508188754485249/bzFcCErV_400x400.jpg" alt="iloverx6000"/>
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2 text-gray-800">@iloverx6000</div>
              <p className="text-gray-700 text-base">
                Tracking AMD RX 6000 GPUs.
              </p>
            </div>
          </div>
        </a>
      </div>
      <div className="flex justify-center mb-5 flex-col content-center">
        <a href="https://discord.gg/NDv2HdmTAD" className="self-center">
          <img src={JoinDiscordButton} className="w-48" alt="Join Discord"/>
        </a>
        <div className="self-center text-sm mt-2 mb-5 opacity-75 text-center">
          <p>All stock changes are simultaneously announced on Twitter <b>and</b> Discord!</p>
        </div>
      </div>
    </div>
  );
}

export default Header;
